"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const Yup = __importStar(require("yup"));
const GenericComponents_1 = require("../../../../View/Modals/CommonFormComponents/GenericComponents");
function makeOfferBondValidationSchema(isEditing) {
    return Yup.object().shape({
        _offerBond: Yup.object().shape({
            value: GenericComponents_1.valueValidation,
            form: Yup.string().required("Forma jest wymagana"),
            paymentData: Yup.string()
                .required("Dane do płatności są wymagane")
                .max(300, "Dane do płatności mogą mieć maksymalnie 300 znaków"),
            comment: Yup.string().max(500, "Uwagi mogą mieć maksymalnie 500 znaków"),
            status: Yup.string().required("Status jest wymagany"),
            expiryDate: Yup.date().required("Data ważności jest wymagana"),
        }),
    });
}
exports.default = makeOfferBondValidationSchema;
